import { PlaceholderView } from "./placeholder";
import { TemplateManager } from "../../shared/helpers/template-manager";
import { autoinject } from "aurelia-dependency-injection";
import { OverviewView } from "./overview";
import { WelcomeModel } from "../../search/models/welcome";
import { UserHistoryView } from "../../user-history/views/user-history";
import { UserHistoryModel } from "../../user-history/models/user-history";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AlertsView } from "./alerts";
import { AlertsModel } from "../models/alerts";
import { AlertsJurisdictionModel } from "../models/alerts-jurisdiction";
import { AuthorizationModel } from "../../authentication/models/authorization-model";
import { AppSettings } from "../../app-settings";
import { AuthService } from "../../authentication/auth-service";
import { AppUser } from "../../authentication/app-user";

require("../styles/my-justis.less");

const template = require<string>("./my-justis.html");

const dom = {
    CONTENT_REGION: "#my-justis-content-region",
    NAV_ITEMS: ".my-justis-subregion-navigation li a"
};

@autoinject
@backboneViewProperties({
    template: template,
    tagName: "div",
})
export class MyJustisView extends Marionette.LayoutView<any> {

    private overviewView: OverviewView;
    private alertsView: AlertsView;
    private historyView: UserHistoryView;

    private contentRegion: Marionette.Region;
    private user: AppUser;

    constructor(private authService: AuthService, private templateManager: TemplateManager,  private appEvents: Backbone.Events) {
        super();
        this.user = authService.AppUser;
    }

    public regions(): any {
        return {
            contentRegion: dom.CONTENT_REGION
        };
    }

    public onShow() {
        this.setupSubViews();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click a"] = (e) => this.handleNavigationClick(e);
        return events;
    }

    public showSection(section, subsection) {
        section = section || "overview";
        $(dom.NAV_ITEMS).parent().removeClass("active");
        $(dom.NAV_ITEMS).filter(`[href*='${section}']`).parent().addClass("active");
        switch (section) {
            case "alerts":
                this.openAlerts(subsection);
                break;
            case "history":
                this.openHistory();
                break;
            default:
                this.openOverview();
        }
    }

    private setupSubViews() {
        this.overviewView = this.overviewView || new OverviewView(this.appEvents);
        const alertingModel = new AlertsModel();
        this.alertsView = this.alertsView || new AlertsView("searches", this.user, alertingModel);
    }

    private openOverview() {
        this.contentRegion.show(this.overviewView, {preventDestroy: true});
        this.overviewView.onShow();
    }

    private openAlerts(subsection?: string) {
        this.alertsView.model.Section = subsection || "searches";
        this.contentRegion.show(this.alertsView, {preventDestroy: true});
    }

    private openHistory() {
        const historyModel = new UserHistoryModel();
        this.templateManager.getTemplate("userhistory").then((templ) => {
            this.historyView = new UserHistoryView(this.user, historyModel);
            this.historyView.template = templ.Raw;
            this.contentRegion.show(this.historyView, {preventDestroy: true});
        }).catch((error) => {
             //
        });
    }

    private handleNavigationClick(e: JQueryEventObject) {
        e.preventDefault();
        e.stopPropagation();
        $(e.currentTarget).addClass("selected");
        const url = $(e.currentTarget).attr("href");
        if (url) {
            Backbone.history.navigate(url, { trigger: true });
        }
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/my-justis.ts